// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__Bmatc","submitButton":"styles_submitButton__QpW9o"};